import {
  LabeledButton,
  LabeledButtonContent,
  LabeledButtonLabel,
} from "@babackapp/customer-ui/components/button";
import { DateSelect } from "@babackapp/customer-ui/components/date-select";
import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionContent,
  OptionDescription,
  OptionIcon,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { ChevronsUpDown, MailboxIcon } from "lucide-react";
import { Controller, type Control } from "react-hook-form";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import {
  isPickupDayDisabled,
  localDateFromString,
  localDateToString,
  type PickupRule,
} from "@babackapp/return-widget-components/lib/pickup.lib";

type FormValues = {
  returnMode: string;
  pickupDate?: string;
  storeId?: string;
  isPickup?: boolean;
};

type Props = {
  control: Control<FormValues>;
  selected: boolean;
  isPickup?: boolean;
  pickupRule?: PickupRule | null;
  error?: string;
};

export function CarrierOption({ control, selected, isPickup, pickupRule, error }: Props) {
  const t = useCustomText();
  return (
    <Label htmlFor="carrier">
      <Option>
        <OptionIcon>
          <MailboxIcon />
        </OptionIcon>
        <OptionTitle>{t("returnMode.carrier.title")}</OptionTitle>
        <OptionDescription>
          {t("returnMode.carrier.description")}
        </OptionDescription>
        {isPickup && selected && (
          <OptionContent>
            <Controller
              control={control}
              name="pickupDate"
              render={({ field }) => (
                <DateSelect
                  className="w-full"
                  selected={field.value ? localDateFromString(field.value) : undefined}
                  disabledDays={(date) => isPickupDayDisabled(pickupRule, date)}
                  onSelect={(date) =>
                    field.onChange(date ? localDateToString(date) : undefined)
                  }
                >
                  <LabeledButton variant="outline" aria-invalid={!!error}>
                    <LabeledButtonLabel>{t("returnMode.carrier.pickupDate")}</LabeledButtonLabel>
                    <LabeledButtonContent>
                      {field.value
                        ? localDateFromString(field.value).toLocaleDateString("fr-FR")
                        : t("returnMode.carrier.noDateSelected")}
                    </LabeledButtonContent>
                    <ChevronsUpDown />
                  </LabeledButton>
                </DateSelect>
              )}
            />
          </OptionContent>
        )}
        <OptionAction>
          <RadioGroupItem value="carrier" id="carrier" />
        </OptionAction>
      </Option>
    </Label>
  );
}
